import { ReferenceLinkMapper } from '../../mappers/ReferenceLinkMapper';
import { SeverityMapper } from '../../mappers/SeverityMapper';
import { GQLIdEncoder } from '../../utils/GQLIdEncoder';
import { Issue } from '../models/Issue';
import { Details } from '../models/valueObjects/Details';

export class IssueMapper {
  private readonly encoder = new GQLIdEncoder();
  private readonly severityMapper = new SeverityMapper();
  private readonly referenceLinkMapper = new ReferenceLinkMapper();

  mapToDomain(data: any): Issue {
    const id = this.encoder.decode(data.id);
    const severity = this.severityMapper.mapSeverity(data.severity);
    const references = this.referenceLinkMapper.mapFromKbLink(data);
    const consequence = new Details(data.consequences, data.explanation, data.expertise, data.access, data.resources, references);

    return new Issue(id, data.title, data.number, data.shortExplanation, severity, data.numberOfSlots, consequence);
  }
}
